import { useUserPermissions } from '../../contexts/UserPermissionsContext'

export function useHandbookAccess() {
  const { accessFlags, accessFlagsEmail, effectiveUserEmail, isLoadingAccessFlags, isLoadingOverride } = useUserPermissions()
  // Never reuse the previous person's permissions during a View As change.
  const ready = Boolean(effectiveUserEmail) && !isLoadingAccessFlags && !isLoadingOverride &&
    accessFlagsEmail?.trim().toLowerCase() === effectiveUserEmail?.trim().toLowerCase()
  return { ready, allowed: ready && accessFlags.systemDev === true }
}
